import React, {Suspense} from 'react'
import {ProductListInformationFragment} from '@data/__generated__/types.main'
import orderCategoryFragment from '@data/fragments/categories/orderCategory.main'
import classnames from '@helpers/misc/classnames'
import orderBy from 'lodash/orderBy'

import {orderCategory} from './__generated__/orderCategory'
import Product from './Product'
import Skeleton, {ProductSkeleton} from './Skeleton'
import withProductCardExperiment from './withProductCardExperiment'

import styles from './styles.module.css'

export interface CategoryProps {
  menuId: string
  category: orderCategory
  hidePrice: boolean
  layout: string
  productsLayout: string
  productCardDesign: string
  sorting: any
  hideNotAvailableProducts: boolean
  cardsV2: boolean
}

//TODO: this logic should be sent to backend when hideNotAvailableProducts option is divided into to functionalities
export const filterUnavailableProducts =
  (hideNotAvailableProducts: boolean) => (product: ProductListInformationFragment) => {
    if (hideNotAvailableProducts && product.isOutOfStock) {
      return false
    }
    if (!product.availabilityAt) return false
    if (product.availabilityAt.notAvailableMessage) return true

    return !!product.availabilityAt.available
  }

class CategoryInner extends React.Component<CategoryProps> {
  static fragment = orderCategoryFragment

  getProducts() {
    const filterUnavailableProductsFn = filterUnavailableProducts(
      this.props.hideNotAvailableProducts
    )
    let productList = this.props.category.products.filter(filterUnavailableProductsFn)

    if (this.props.sorting) {
      if (this.props.sorting.type === 'price') {
        productList = orderBy(productList, product => product.availabilityAt.finalPrice, [
          this.props.sorting.order
        ])
      }

      if (this.props.sorting.type === 'name') {
        productList = orderBy(productList, ['name'], [this.props.sorting.order])
      }

      if (this.props.sorting.type === 'timesPurchased') {
        productList = orderBy(productList, ['timesPurchased'], [this.props.sorting.order])
      }
    }

    return productList
  }

  renderProducts() {
    let className =
      this.props.productsLayout === 'compact'
        ? {
            mobile: 'col-xs-6',
            v1: 'col-xs-6 col-md-3',
            v2: 'col-xs-3 col-md-2'
          }[this.props.layout]
        : {
            mobile: 'col-xs-12',
            v1: 'col-xs-12 col-md-6',
            v2: 'col-xs-6 col-md-4'
          }[this.props.layout]
    className += ' menuProductCol'
    if (this.props.cardsV2) {
      className = ''
    }
    return this.getProducts().map(product => {
      return (
        <div key={product._id} className={className}>
          <Suspense fallback={<ProductSkeleton />}>
            <Product
              productsLayout={this.props.productsLayout}
              productCardDesign={this.props.productCardDesign}
              hidePrice={this.props.hidePrice}
              // @ts-expect-error ts-migrate(2739) FIXME: Type 'orderCategory_products' is missing the follo... Remove this comment to see the full error message
              product={product}
              menuId={this.props.menuId}
            />
          </Suspense>
        </div>
      )
    })
  }

  render() {
    const {category} = this.props
    const cardsV2 = this.props.cardsV2
    if (this.getProducts().length === 0) return null
    const isCardv2Compact = this.props.productCardDesign.includes('vertical-compact')
    const cardvProductsLayoutStyle = classnames('flex flex-row flex-wrap gap-4', {
      'justify-start': isCardv2Compact,
      'justify-center md:justify-start': !isCardv2Compact
    })
    const productsStyle = cardsV2 ? cardvProductsLayoutStyle : styles.products
    return (
      <>
        {/* The id of the div bellow is intended as a unique match to Tiramisu's
      layout. Please do not change it. */}
        <div className={styles.container} id={`t111_${category._id}`}>
          <div className={styles.name}>{category.name}</div>
          <div className={productsStyle}>
            {cardsV2 ? this.renderProducts() : <div className="row">{this.renderProducts()}</div>}
          </div>
        </div>
      </>
    )
  }
}

function Category(props: CategoryProps) {
  return (
    <Suspense fallback={<Skeleton />}>
      <CategoryInner {...props} />
    </Suspense>
  )
}
export default withProductCardExperiment(Category)
